import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as $ from 'jquery';
import Moment from 'moment';

import { orderEdit, orderCreate } from '../../../redux/actions/order/orderActions';
import { appointmentLoad } from '../../../redux/actions/appointmentActions';
import { staffsLoad } from '../../../redux/actions/staffActions';
import { claimFormReset } from '../../../redux/actions/order/claimFormActions';
import { tabChange } from '../../../itrust_common/redux/actions/otherActions';

import Alert from '../../../itrust_common/components/Alert';
import { patientReportsLoad } from '../../../itrust_common/redux/actions/settingActions/patientReportActions';
import { onBoardingTourInfoReset } from '../../../redux/actions/onBoardingActions';
import { quickActionsReset } from '../../../redux/actions/dashboard/quickActionActions';
import { patientReset } from '../../../redux/actions/patient/patientActions';
import { visionInsuranceClaimFormReset } from '../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction';

class CreateOrderButton extends Component {

  handleOrderSubmit(data) {
    const { activeTourType } = this.props
    if (activeTourType === 'create_order') {
      this.props.dispatch(onBoardingTourInfoReset(activeTourType))
    }
    if (localStorage.getItem('StoreID') == null) {
      Alert.warning("Please select store from top dropdown.")
    } else {
      const { patient, store, appointmentId, isQuickAction } = this.props
      Alert.confirm(
        <div className="d-flex">You’re creating a new order for <strong className="px-2">{patient.name}</strong> at <strong className="px-2">{store.name}</strong>.</div>,
        (response)=>{
          if(response)
          new Promise((resolve, reject) => {
            this.props.dispatch(claimFormReset())
            this.props.dispatch(visionInsuranceClaimFormReset())
            this.props.dispatch(tabChange({order: 1}))
            this.props.dispatch(orderCreate(data, { include: '*' }))
              .then((response) => {
                var res = response.value.data.order
                this.props.dispatch(orderEdit(res.id));
                this.props.dispatch(patientReportsLoad({patient_id: res.patient_attributes.id, staff_id: res.staff_id, store_id: res.store_attributes.id, filter: {category: "invoice"}}))
                this.props.dispatch(staffsLoad({ rpp: 9999, filter: { selected_store: this.props.store.id } }))
                //Load appointment if order created from appointment
                if (appointmentId)
                  this.props.dispatch(appointmentLoad(appointmentId, { include: ['patient', 'staff', 'procedures', 'examination', 'order'] }))
                $('#orderForm-modal').modal('show');
              })
          })
      })
    }
  }

  handleQuickActionClose() {
    const { dispatch } = this.props;
    $('#patientSelect-modal').modal('hide');
    dispatch(quickActionsReset())
    dispatch(patientReset())
  }

  render() {
    const { patientId, appointmentId, currentUser } = this.props;
    var staffId = currentUser.id
    return (
      <span>
        <span
          className="pointer"
          onClick={this.handleOrderSubmit.bind(this, { status: 'unfinished', order_date: Moment(new Date()).format("YYYY/MM/DD"), patient_id: patientId, staff_id: staffId, appointment_id: appointmentId })}
        >
          {this.props.children}
        </span>
      </span>
    );
  }
}

function mapStateToProps(state) {
  const { patient, currentStore, auth } = state;
  return {
    patient: patient.patient,
    store: currentStore.store,
    currentUser: auth.user
  };
}

export default connect(mapStateToProps)(CreateOrderButton);
